"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _commonReact = require("@devsta/common-react");

function SelectedClipTitle(_ref) {
  var asset = _ref.asset;
  return asset && asset.title || '';
}

var _default = (0, _commonReact.withAssetSelector)(SelectedClipTitle);

exports.default = _default;